import axios from 'axios';

export const fetchPlants = async (token) => {
  try {
    const response = await axios.get('/api/v1/plants', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    // Response already has the correct format from our local endpoint
    return response.data;
  } catch (error) {
    console.error('Error fetching plants:', error);
    throw error;
  }
}; 